import { render, staticRenderFns } from "./EditApiInfo.vue?vue&type=template&id=487ff1b5&"
import script from "./EditApiInfo.vue?vue&type=script&lang=js&"
export * from "./EditApiInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports